import React, { useState, useEffect } from "react";
import { TextInput, PasswordInput, Button, Text, Anchor, Stack, Title, Paper, Alert } from "@mantine/core";
import { useDispatch, useSelector } from "react-redux";
import { validateUser } from "../Redux/user/slice";
import { Navigate } from "react-router-dom";
import { FormattedMessage, useIntl } from "react-intl";
import { IconAlertCircle } from "@tabler/icons-react";

export default function SignIn() {
  const intl = useIntl();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [emailError, setEmailError] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const dispatch = useDispatch();
  const [isUser, setIsUser] = useState(false);

  const { isUserLoggedIn, invalidUser } = useSelector((s) => s.user);

  useEffect(() => {
    if (isUserLoggedIn) setIsUser(true);
  }, [isUserLoggedIn]);

  useEffect(() => {
    if (invalidUser) {
      if (
        invalidUser.includes("404") ||
        invalidUser.includes("not found") ||
        invalidUser.toLowerCase().includes("invalid")
      ) {
        setPasswordError(intl.formatMessage({ id: "login.invalid.credentials", defaultMessage: "Invalid credentials" }));
      } else if (invalidUser.toLowerCase().includes("email")) {
        setEmailError(intl.formatMessage({ id: "login.email.invalid", defaultMessage: "Invalid email" }));
      } else {
        setPasswordError(intl.formatMessage({ id: "login.error.generic", defaultMessage: "An error occurred" }));
      }
    }
  }, [invalidUser, intl]);

  const handleSubmit = (e) => {
    e.preventDefault();
    setEmailError("");
    setPasswordError("");

    if (!email) {
      setEmailError(intl.formatMessage({ id: "login.email.required", defaultMessage: "Email is required" }));
      return;
    }
    if (!password) {
      setPasswordError(intl.formatMessage({ id: "login.password.required", defaultMessage: "Password is required" }));
      return;
    }

    dispatch(validateUser({ email, password, cb: () => {} }));
  };

  return (
    <>
      {isUser && <Navigate to="/" replace={true} />}
      <Paper
        withBorder
        shadow="sm"
        p="xl"
        radius="md"
        style={{ width: "100%", maxWidth: 400 }}
      >
        <Stack spacing="xs" mb="lg">
          <Title order={3} style={{ color: "#009688" }}>
            <FormattedMessage id="login.title" defaultMessage="Sign in" />
          </Title>
          <Text size="sm" color="dimmed">
            <FormattedMessage id="login.subtitle" defaultMessage="Welcome back to Verto" />
          </Text>
        </Stack>

        <form onSubmit={handleSubmit} noValidate>
          <Stack spacing="md">
            <TextInput
              label={<FormattedMessage id="login.email" defaultMessage="Email" />}
              type="email"
              value={email}
              onChange={(e) => { setEmail(e.target.value); setEmailError(""); }}
              error={emailError || undefined}
              autoComplete="email"
              autoFocus
              required
            />
            <PasswordInput
              label={<FormattedMessage id="login.password" defaultMessage="Password" />}
              value={password}
              onChange={(e) => { setPassword(e.target.value); setPasswordError(""); }}
              error={passwordError || undefined}
              autoComplete="current-password"
              required
            />
            <Anchor href="/reset-password" size="xs" style={{ color: "#009688", alignSelf: "flex-end", marginTop: -8 }}>
              <FormattedMessage id="login.forgot" defaultMessage="Forgot password?" />
            </Anchor>
            <Button
              type="submit"
              fullWidth
              mt="xs"
              style={{ backgroundColor: "#009688", border: "none" }}
            >
              <FormattedMessage id="login.submit" defaultMessage="Sign In" />
            </Button>
          </Stack>
        </form>
      </Paper>
    </>
  );
}